module.exports = __webpack_public_path__ + "media/components/assets/icons/logo_main-704ea277fa2aeeaeb7ccad0bbaab3eab.svg";